module.exports = __webpack_public_path__ + "img/about5.1c5707c7.png";